import React from "react";
import { PropTypes } from "prop-types";
import { FormField, Select as KuiSelect } from "@kui/foundations-react";

// Option with this key is the "Select an Option" placeholder row of the old native <select>
const PLACEHOLDER_KEY = "0";

const Select = props => {
  const valueField = props.valueFieldName ? props.valueFieldName : "key";
  const displayField = props.displayFieldName ? props.displayFieldName : "value";

  const placeholderItem = props.optionValues.find(
    o => String(o[valueField]) === PLACEHOLDER_KEY
  );
  const items = props.optionValues
    .filter(o => String(o[valueField]) !== PLACEHOLDER_KEY)
    .map(o => ({ value: String(o[valueField]), children: o[displayField] }));

  // value 0 means "nothing chosen" in App state; an empty string shows the placeholder
  let value;
  if (props.value !== undefined) {
    value = String(props.value) === PLACEHOLDER_KEY ? "" : String(props.value);
  }

  // App handlers only read e.target.value, so hand them a minimal event-like object
  const handleValueChange = v => {
    if (props.onChange) props.onChange({ target: { value: v } });
  };

  return (
    <div className="regField" data-field-error={props.errorText ? "true" : undefined}>
    <FormField
      id={props.id}
      slotLabel={props.labelText}
      slotError={props.errorText}
      status={props.errorText ? "error" : undefined}
      required={props.isRequired}
      labelPosition="top"
    >
      <KuiSelect
        size="medium"
        items={items}
        value={value}
        placeholder={placeholderItem ? placeholderItem[displayField] : "Select an option"}
        onValueChange={handleValueChange}
        disabled={props.readOnly}
      />
    </FormField>
    </div>
  );
};

Select.propTypes = {
  optionValues: PropTypes.array.isRequired,
  isRequired: PropTypes.bool,
  labelText: PropTypes.string.isRequired,
  errorText: PropTypes.node,
  id: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  isVMWare: PropTypes.bool,
  displayFieldName: PropTypes.string,
  valueFieldName: PropTypes.string
};

Select.defaultProps = {
  readOnly: false,
  isVMWare:false
};


export default Select;
